export default __webpack_public_path__ + "static/media/arrow.5d4a5fe5.svg";